import type { HTMLAttributes } from 'react';
import { cx } from './cx';

type Size = 'xl' | 'lg' | 'md';
const sizes: Record<Size, string> = {
  xl: 'text-display-xl',
  lg: 'text-display-lg',
  md: 'text-display-md',
};

export interface DisplayProps extends HTMLAttributes<HTMLHeadingElement> {
  size?: Size;
  as?: 'h1' | 'h2' | 'h3';
}

export function Display({ size = 'lg', as: As = 'h1', className, ...rest }: DisplayProps) {
  return <As className={cx('display', sizes[size], className)} {...rest} />;
}
